class LocalStorageKeys {
  static coachToken = "ghkjhfdkivhgrowihgiot-ioyrfiyity";
}
export default LocalStorageKeys;
